var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autotask-export-contact-widget"},[_c('autotask-export-widget-contacts-step',{attrs:{"selectedContacts":_vm.selectedContacts,"url":_vm.webUrl},on:{"closeWidget":function($event){return _vm.closeWidget($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }